// The names of the default four columns shown across the app
export const DEFAULT_COLUMNS = [
  "rCourseQuality",
  "rInstructorQuality",
  "rDifficulty",
  "rWorkRequired"
];

// All column names inherent to the data provided by the ISC
export const ALL_DATA_COLUMNS = [
  "rCourseQuality",
  "rInstructorQuality",
  "rDifficulty",
  "rAmountLearned",
  "rWorkRequired",
  "rReadingsValue",
  "rCommAbility",
  "rInstructorAccess",
  "rStimulateInterest",
  "rTAQuality",
  "rRecommendMajor",
  "rRecommendNonMajor"
];

export const PERCENTAGE_COLUMNS = ["rPercentOpen", "rFilledInAdvReg"];

export const REGISTRATION_METRICS_COLUMNS = [
  "rPercentOpen",
  "rFilledInAdvReg",
  "rNumOpenings",
  "rFinalEnrollment"
];

export const COLUMN_FULLNAMES = {
  rCourseQuality: "Course Quality",
  rInstructorQuality: "Instructor Quality",
  rDifficulty: "Difficulty",
  rAmountLearned: "Amount Learned",
  rWorkRequired: "Amount of Work",
  rReadingsValue: "Value of Readings",
  rCommAbility: "Instructor Communication",
  rInstructorAccess: "Instructor Accessibility",
  rStimulateInterest: "Ability to Stimulate Interest",
  rTAQuality: "TA Quality",
  rRecommendMajor: "Recommend for Majors",
  rRecommendNonMajor: "Recommend for Non-Majors"
};

export const COLUMN_SHORTNAMES = {
  rCourseQuality: "Course",
  rInstructorQuality: "Instructor",
  rDifficulty: "Difficulty",
  rAmountLearned: "Learned",
  rWorkRequired: "Workload",
  rReadingsValue: "Reading",
  rCommAbility: "Instr Comm",
  rInstructorAccess: "Access",
  rStimulateInterest: "Interest",
  rTAQuality: "TA Quality",
  rRecommendMajor: "Major",
  rRecommendNonMajor: "Non-Major"
};
